<template>
  <div>
    <div class="app-title">
      <em-view-title :crudState="$_emCommonListMixin_pathType"></em-view-title>
    </div>
    <section class="app-content" v-menu-permission="'list'">
      <div id="accordionFilter" class="content">
        <div class="card">
          <div
            id="collapseOne"
            class="collapse show"
            aria-labelledby="headingOne"
            data-parent="#accordionFilter"
          >
            <div class="card-body">
              <form>
                <em-filter
                  queryApi="findExecute"
                  entity="sithMesAndonTask"
                  ref="emListFilter"
                  @showEntityModalSelect="
                    $_emCommonModalMixin_showModalSelectorByFilter
                  "
                ></em-filter>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div id="sithMesAndonTaskResultTable" class="content">
        <div class="card my-1">
          <div
            id="collapseTwo"
            class="collapse show"
            aria-labelledby="headingTwo"
            data-parent="#accordionResult"
          >
            <div class="card-body">
              <em-table
                queryApi="findExecute"
                with-custom-row-actions-first-column
                custom-row-actions-text-first-column="操作"
                entity="sithMesAndonTask"
                ref="emTable"
                exportDisabled
                :inlineActionsDisabled="prop_inline !== '1'"
                @showModalSelectorByNewRow="
                  $_emCommonModalMixin_showModalSelectorByNewRow
                "
                @showModalSelectorByEditRow="
                  $_emCommonModalMixin_showModalSelectorByEditRow
                "
              >
                <template #customRowActionsFirstColumn="{row}">
                  <b-button-group>
                    <em-button
                      type="responseTask"
                      v-bind:class="'btn btn-outline-primary btn-sm'"
                      @click="responseTask(row)"
                    ></em-button>
                    <!-- <em-button
                      type="finishTask"
                      v-bind:class="'btn btn-outline-primary btn-sm'"
                      @click="finishTask(row)"
                    ></em-button> -->
                  </b-button-group>
                </template>
              </em-table>
            </div>
          </div>
        </div>
      </div>
    </section>
    <em-modal-entity-selector
      ref="emModalEntitySelector"
    ></em-modal-entity-selector>
  </div>
</template>
<script>
// Author Eric
// Date 2020-10-10 10:16:05

import emCommonListMixin from "@/mixin/em/common/list";
import emCommonApi from "@/mixin/em/common/api";
import commonViewsUtil from "@/utils/commonViewsUtil";

export default {
  name: "sithMesAndonTaskList",
  mixins: [emCommonListMixin, emCommonApi],

  props: {
    //是否启用行编辑
    prop_inline: {
      type: String,
      default: "0"
    }
  },
  // created() {
  //   this.$refs.emListFilter.idFilter = this.$route.query.id;
  // },
  methods: {
    responseTask(row) {
      const _api =
        this.$store.state.sithMesAndonTask.baseModuleUrl +
        "/sithMesAndonTask/selective";
      // let url = this.baseModuleUrl + "/sithMesAndonTask/selective";

      this.$_emApiMixin_put(_api, {
        id: row.id,
        status: 2,
        responseTime: this.$_emApiMixin_dateFormat(new Date())
      }).then(data => {
        this.calendarShiftList = data.data;
        commonViewsUtil.showSuccess(this, "响应成功");
        this.$refs.emListFilter.doQuery();
      });
    },
    finishTask(row) {
      const _api =
        this.$store.state.sithMesAndonTask.baseModuleUrl +
        "/sithMesAndonTask/selective";
      // let url = this.baseModuleUrl + "/sithMesAndonTask/selective";

      this.$_emApiMixin_put(_api, {
        id: row.id,
        status: 4,
        finishTime: this.$_emApiMixin_dateFormat(new Date())
      }).then(data => {
        this.calendarShiftList = data.data;
        commonViewsUtil.showSuccess(this, "处理成功");
      });
    }
  },
  computed: {
    modelName() {
      return this.$_emRouterHelperMixin_entityName;
    }
  },
  watch: {
    $_emCommonListMixin_newNotification(newValue, oldValue) {
      console.log("$_emCommonListMixin_newNotification changed");
      //todo 测试用，实际应该增加对通知的判断（是否安灯任务通知），以及对当前页面状态的判断（正在编辑就不刷新）
      newValue && this.$refs["emListFilter"].doQuery();
    },
    $route: {
      handler() {
        this.$refs["emListFilter"].$_emCustomVuexMixin_filterStore.idFilter = this.$route.query.id;
        this.$refs["emListFilter"].doQuery();
      },
      deep: true
    }
  },
  //覆写ListMixin的mounted，不管是否需要刷新了，每次进入都刷新
  mounted() {
    this.$refs["emListFilter"].$_emCustomVuexMixin_filterStore.idFilter = this.$route.query.id;
    // this.$store.dispatch("emBase/emBaseQueryByFilter", {entity: this.modelName})
    this.$refs["emListFilter"].doQuery();
  }
};
</script>
